// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "webcams" + "." + "1978d6bf" + ".css";
};